export default "/images/vendor/flag-icon-css/flags/4x3/pm.svg?c5a64f87b2370f6a2ae3cf9d6523c9e4";